'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBemReact = require('@yandex-lego/i-bem-react');

var _iBemReact2 = _interopRequireDefault(_iBemReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBemReact.decl)({
    block: 'menu',
    elem: 'group',
    tag: function tag(_ref) {
        var isNavigation = _ref.isNavigation;

        if (isNavigation) {
            return 'ul';
        }

        return this.__base();
    },
    attrs: function attrs() {
        return { role: 'group' };
    },
    content: function content(_ref2) {
        var title = _ref2.title,
            children = _ref2.children;

        var content = [];
        if (title) {
            content.push(_react2.default.createElement(
                _iBemReact2.default,
                {
                    block: this.block,
                    elem: 'title',
                    attrs: { 'aria-hidden': 'true' }
                },
                title
            ));
        }

        return [].concat(content, children).map(function (child, i) {
            return _react2.default.cloneElement(child, { key: 'in-group-' + i }); // eslint-disable-line react/no-array-index-key
        });
    }
}, {
    propTypes: {
        title: _propTypes2.default.string
    },
    isGroup: function isGroup(child) {
        return child && typeof child.type === 'function' && child.type.displayName === 'menu__group';
    }
});